<template>
  <div class="grid-component-section section">
    <div class="grid-component-title">
      {{name}}
      <div class="edit-button" @click.stop="handleEditButton">
        <i class="fa fa-pencil" />
      </div>
    </div>
    <DisplayGrid :items.sync="items" />
    <EmptyMessage class="empty-container" v-if="!hasItems">
      ไม่มีหมวดหมู่
    </EmptyMessage>
  </div>
</template>

<script>
import _ from 'lodash';
import EmptyMessage from '@/components/EmptyMessage.vue';
import DisplayGrid from './components/DisplayGrid.vue';

export default {
  props: {
    name: {
      type: String,
    },
    items: {
      type: Array,
      default: () => [],
    },
    id: {
      type: String,
    },
  },
  components: {
    DisplayGrid,
    EmptyMessage,
  },
  computed: {
    pageDesignerKey() {
      return this.$route.params.pageDesignerKey;
    },
    hasItems() {
      if (!this.items) {
        return false;
      } if (this.items.length === 0) {
        return false;
      }
      return true;
    },
  },
  methods: {
    handleEditButton() {
      this.$router.push(`${this.pageDesignerKey}/editgrid/${this.id}`);
    },
    getClassContent(item) {
      const content = _.get(item.contentCategory, 'key', '');
      switch (content) {
        case 'homeroom-homerun': return 'bg-altv-homeroom';
        case 'smart-classroom': return 'bg-altv-smart-classroom';
        case 'activity': return 'bg-altv-activity';
        case 'tutor-hub': return 'bg-altv-tutor-hub';
        case 'knowledge-pool': return 'bg-altv-knowledge-pool';
        case 'active-learning-news': return 'bg-altv-news';
        default: return 'bg-altv-homeroom';
      }
    },
    getBoxclass(index) {
      if (index > 1) {
        return 'mockup-box-small';
      }
      return 'mockup-box-big';
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/layouts/page.scss';
@import './src/assets/scss/themes/components/section-container.scss';

.grid-component-section {
  background: white;
  // height: 800px;
  padding: $spacer / 2 $spacer;
  .grid-component-title {
    display: flex;
    align-items: center;
    font-size: $font-size-base * 1.75;
    font-family: $font-family-DBHeavent !important;
    .edit-button {
      cursor: pointer;
      margin-left: auto;
      height: 24.5px;
    }
  }
}
</style>
